import { UsageBalanceData } from "../contracts/types";
import { mapBurndownToUsageBalance } from "shared-ui/src/features/contracts-feature/mapBurndownToUsageBalance";
import { getContractBurndown } from "@features/projects-feature/hooks/useGetContractBurndown";

export function useRecurringServiceUsageBalance(
  contractId?: number,
): UsageBalanceData {
  const { data, isLoading, error } = getContractBurndown(contractId);

  const mapped = mapBurndownToUsageBalance(data);

  return {
    ...mapped,
    isLoading,
    error,
  };
}
